import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-200 text-gray-600 py-4 text-center">
      <p className="text-sm">
        This campaign is against all products supporting Israel, We stand with
        Gaza.
      </p>
      <p className="text-sm mt-2">Long Live Palestine 🇵🇸 </p>
    </footer>
  );
}

export default Footer;
